// Copied from ds/src/lib/blocks/SidebarToggleBtn/SidebarToggleBtn.tsx
import clsx from 'clsx';

import { useSidebarContext } from '@/ds/contexts/sidebar/context';

export function SidebarToggleBtn() {
  const { toggle, isExpanded } = useSidebarContext();

  return (
    <button
      onClick={toggle}
      className={clsx(
        isExpanded && 'active',
        'sidebar-toggle-btn text-primary-600 dark:text-primary-400 flex size-7 cursor-pointer flex-col justify-center space-y-1.5 outline-hidden focus:outline-hidden ltr:ml-0.5 rtl:mr-0.5'
      )}
    >
      <span />
      <span />
      <span />
    </button>
  );
}
